/// <reference path="../../references.ts" />

'use strict';
import Prerender from './prerender.srv';

angular.module('prerender', ['ui.router'])
	.run(require('./prerender-routing-binder.run'))
	.service('prerender', Prerender);
